export default __webpack_public_path__ + "static/logo9-322ad2b6b8872bf496a8787508b68d1c.png";